/**
 * @see https://developer.mozilla.org/en-US/docs/Web/Media/Guides/Formats/Image_types
 */
const IMAGE_EXTENSIONS = [
    '.apng',
    '.avif',
    '.gif',
    '.jpg',
    '.jpeg',
    '.png',
    '.svg',
    '.webp',
    '.bmp',
    '.ico',
    '.tif',
    '.tiff',
] as const;

/**
 * Check if a file is an image file by its extension.
 * @param filename The name of the file to check.
 * @returns The file is an image file.
 */
export function isImageFile(filename: string | null | undefined): boolean {
    if (!filename) {
        return false;
    }
    const filenameLowercase = filename.toLowerCase();
    return IMAGE_EXTENSIONS.some((ext) => filenameLowercase.endsWith(ext));
}
